import type { CanvasEx } from '@/typings/canvas';

/**
 * CanvasEx._updateWorkspaceSize() sizes the canvas backing store from the artwork resolution and
 *  then sets the CSS size independently, so one canvas unit is not one screen pixel. Anything drawn
 *  on the canvas (controls) or positioned against it (DOM overlays) has to convert design values
 *  expressed in screen pixels, or they drift with whatever artwork happens to be open.
 * @returns canvas units per screen pixel
 */
export const canvasUnitsPerPixel = (canvas?: CanvasEx | null): number => {
    const cssWidth = canvas?.upperCanvasEl?.clientWidth;
    return cssWidth ? canvas.getWidth() / cssWidth : 1;
};
